import React, {useEffect} from "react";
import { GetProfileImages } from "../../DocumentDetails/slice";
import * as ReactDOM from "react-dom";
import {
  Grid,
  GridColumn as Column,
  GridNoRecords,
} from "@progress/kendo-react-grid";
import "@progress/kendo-theme-material/dist/all.css";
import { toODataString } from "@progress/kendo-data-query";
import { useDispatch, useSelector } from "react-redux";
import {
  areaOfActivity,
  ComponentType,
  EntityType,
  EntityTypeQuestion,
  RegistrationPortugeseStatus,
  RegistrationPortugeseStatusPendingRegister,
  RegistrationStatus,
  UserType,
} from "../../../common/enum";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import i18next, { t } from "i18next";
import { useTranslation } from "react-i18next";
import {
  getEntitiesList,
  setAdminGridCountySelect,
  setAdminGridDistrictSelect,
  setAdminViewEntityDetail,
  setDrawerState,
  setEntitiesLimit,
  setEntitiesOffset,
  setSnackbarMessage,
  setSnackbarOpen,
  setSnackbarSeverity,
  setRejectPayload,
  setConfirmationDialog,
  setHeaderTitle,
} from "../adminSlice";
import { DropdownFilterCell } from "../../Datagrid/ColumnMenu";
import { debounce } from "lodash";

import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
  Stack,
  Button,
  Typography,
  Box,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Avatar,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { updateRegistrationDetail , UpdateRegistrationEmail } from "../../OnBoarding/slice";
import { AddressData } from "../../../common/enum/addressData";
import ConfirmDialog from "../../../components/ConfirmDialog";
import { useSnackbar } from "notistack";
import Loader from "../../../components/Loader";
import { green } from "@mui/material/colors";
import { useState } from "react";
import DocumentDetails from "../../DocumentDetails";
import { getDocuments } from "../../DocumentDetails/slice";
import ProfileCell from "../../Datagrid/ProfileCell";
import { $CombinedState } from "@reduxjs/toolkit";
import { IntlProvider, load, LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import esMessages from '../../Donations/DonationCard/tlklang.json';

loadMessages(esMessages, 'pt-PT');

const LoadingPanel = () => {
  const loadingPanel = (
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image" />
      <div className="k-loading-color" />
    </div>
  );
  const gridContent = document && document.querySelector(".k-grid-content");
  return gridContent
    ? ReactDOM.createPortal(loadingPanel, gridContent)
    : loadingPanel;
};

const AreaOfActivityCell = (props) => {
  const { translate } = useSelector((state) => state);

  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  const areaActivity =
    Object.keys(areaOfActivity)[
      Object.values(areaOfActivity).indexOf(
        props.dataItem.entity.areaOfActivity
      )
    ];
  return <td>{t(`${areaActivity}`)}</td>;
};

const GroupEntityCell = (props) => {
  const { translate } = useSelector((state) => state);

  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  return (
    <td>
      {props.dataItem.entity.isGroupEntity
        ? t("group")
        : t("singleEstablisment")}
    </td>
  );
};

const StatusCell = (props) => {
  const { translate } = useSelector((state) => state);

  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  return <td>{t(`${props.dataItem.status}`)}</td>;
};

const TypeCell = (props) => {
  const { translate } = useSelector((state) => state);

  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  let userType =
    Object.keys(UserType)[
      Object.values(UserType).indexOf(props.dataItem.userType)
    ];

  return (
    <td
      style={props.style}
      className={props.className}
      colSpan={props.colSpan}
      role={"gridcell"}
      aria-selected={props.isSelected}
      aria-colindex={props.ariaColumnIndex}
    >
      {t(`${userType}`)}
    </td>
  );
};

const EntityTypeCell = (props) => {
  const { translate } = useSelector((state) => state);

  const { t } = useTranslation();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  let entityType =
    Object.keys(EntityType)[
      Object.values(EntityType).indexOf(props.dataItem.entity.entityType)
    ];

  return <td>{t(`${entityType}`)}</td>;
};

const DistrictCell = (props) => {
  const address = props.dataItem.addresses.filter(
    (item) => item.isHeadquarter === true
  );
  return (
    <td>
      {address.length > 0
        ? address[0].district
        : props.dataItem.addresses[0]?.district}
    </td>
  );
};

const TelephoneCell = (props) => {
  const address = props.dataItem.addresses.filter(
    (item) => item.isHeadquarter === true
  );
  return (
    <td>
      {address.length > 0
        ? address[0].phone
        : props.dataItem.addresses[0]?.phone}
    </td>
  );
};

const CountyCell = (props) => {
  const address = props.dataItem.addresses.filter(
    (item) => item.isHeadquarter === true
  );
  return (
    <td>
      {address.length > 0
        ? address[0].county
        : props.dataItem.addresses[0]?.county}
    </td>
  );
};

const SubDivisionCell = (props) => {
  const address = props.dataItem.addresses.filter(
    (item) => item.isHeadquarter === true
  );
  return (
    <td>
      {address.length > 0
        ? address[0].subDivision
        : props.dataItem.addresses[0]?.subDivision}
    </td>
  );
};

const ViewEntityDetails = ({ t }) => {
  const {
    adminDashboard: { adminViewEntityDetail, entitiesLimit, entitiesOffset },
    auth: {
      profile: { entity },
    },
    documentDetails: {
      documents,
      documentCount,
      documentOffset,
      documentLimit,
    },
  } = useSelector((state) => state);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  function toLocalISOString(inputDate) {
    const date = inputDate instanceof Date ? inputDate : new Date(inputDate);
  
    if (isNaN(date)) {
      throw new Error('Invalid date');
    }
  
    const offsetMs = date.getTimezoneOffset() * 60000;
    const adjustedDate = new Date(date.getTime() - offsetMs);
    return adjustedDate.toISOString().slice(0, -1);
  }
  
  const entityType =
    Object.keys(EntityType)[
      Object.values(EntityType).indexOf(adminViewEntityDetail.entity.entityType)
    ];
  const areaActivity =
    Object.keys(areaOfActivity)[
      Object.values(areaOfActivity).indexOf(
        adminViewEntityDetail.entity.areaOfActivity
      )
    ];

  const entityTypeQuestion = adminViewEntityDetail.entity.isGroupEntity
    ? EntityTypeQuestion.groupUnitManangement
    : EntityTypeQuestion.store;

  React.useEffect(() => {
    const data = {
      entityId: adminViewEntityDetail.entity.entityId,
      limit: 10,
      offset: 0,
    };
    dispatch(getDocuments(data));
  }, []);


  const onApprove = React.useCallback(() => {
    let data = {
      limit: documentLimit,
      offset: documentOffset,
      entityId: adminViewEntityDetail.entity.entityId,
    };
    dispatch(getDocuments(data))
      .unwrap()
      .then((res) => {
       // console.log(res , "isto é o res")
       
        var checkDocuments = res.documents.documents.filter(doc => doc.status == 'WAITING_FOR_VALIDATION')
        if(checkDocuments.length == 0 ){
          const payload = {
            userId: adminViewEntityDetail.entity.entityId,
            status: RegistrationStatus.active,
            registrationApprovedRejectedOn: toLocalISOString(new Date()),
            registrationApprovedRejectedBy: entity.entityId,
          };
          dispatch(updateRegistrationDetail(payload))
            .unwrap()
            .then((res) => {
              let data = {
                limit: entitiesLimit,
                offset: entitiesOffset,
                status: RegistrationStatus.pendingEmailVerification,
              };
              dispatch(getEntitiesList(data));
              dispatch(setDrawerState(false));
              enqueueSnackbar({
                message: t("successfullyApproved"),
                variant: "success",
              });
            })
            .catch((error) => {
              enqueueSnackbar({
                message: t("somethingWentWrong"),
                variant: "error",
              });
            });
        }else{
          
          enqueueSnackbar({
            message: "Valide os documentos antes de aprovar o registo",
            variant: "error",
          });
            
        }
        

      })
    
  }, []);

  const onRejectedHandle = React.useCallback(() => {
    const payload = {
      userId: adminViewEntityDetail.entity.entityId,
      status:
        adminViewEntityDetail.status === RegistrationStatus.active
          ? RegistrationStatus.inActive
          : RegistrationStatus.rejected,
      registrationApprovedRejectedOn: toLocalISOString(new Date()),
      registrationApprovedRejectedBy: entity.entityId,
    };
    dispatch(
      setHeaderTitle(
        adminViewEntityDetail.status === RegistrationStatus.active
          ? t("confirmationDeactivateContent")
          : t("confirmationRejectContent")
      )
    );
    dispatch(setRejectPayload(payload));
    dispatch(setConfirmationDialog(true));
  }, [dispatch]);

  
  const AbrirChangeEmail = React.useCallback(() => {
   $("#divChangeEmail").removeClass("d-none")
  }, []);

  const CancelarChangeEmail = React.useCallback(() => {
    $("#divChangeEmail").addClass("d-none")
   }, []);

  const updateRegister = React.useCallback(() => {
   
      const payload = {
        userId: adminViewEntityDetail.entity.entityId,
        email : $("#AlterarEmail").val(),
      };
      dispatch(UpdateRegistrationEmail(payload))  
      .unwrap()
      .then((res) => {
        const data = {
          limit: entitiesLimit,
          offset: entitiesOffset,
          status: RegistrationStatus.pendingEmailVerification,
        };
        dispatch(getEntitiesList(data))
        dispatch(setDrawerState(false));
              enqueueSnackbar({
                message: "E-mail alterado com sucesso",
                variant: "success",
              }); 
      }) 
    
  }, []);



  const COVER_URL = "/static/illustrations/illustration_default_banner.jpg";
  const AVATAR_URL = "/static/illustrations/illustration_defaultavatar.png";


  const [entitybanneruri, setentitybanneruri] = React.useState("");
  const [profilepictureuri, setprofilepictureuri] = React.useState("");

  useEffect(() => {
  if(adminViewEntityDetail.entity.bannerImage != "string" && adminViewEntityDetail.entity.bannerImage != null ){
       dispatch(GetProfileImages(adminViewEntityDetail.entity.bannerImage))
       .unwrap()
        .then((response) => {
           if(response.isActive != null){
            setentitybanneruri(response.isActive);
          }else{
            setentitybanneruri(COVER_URL);
          }
        })
    }

    if(adminViewEntityDetail.entity.profilePicture != "string" && adminViewEntityDetail.entity.profilePicture != null ){
       dispatch(GetProfileImages(adminViewEntityDetail.entity.profilePicture))
       .unwrap()
        .then((response) => {
          if(response.isActive != null){
            setprofilepictureuri(response.isActive);
          }else{
            setprofilepictureuri(AVATAR_URL);
          }
        })
    }
	})


  return (
    <>
      <Box
        sx={{
          height: "110px",
          backgroundImage: `url(${
            adminViewEntityDetail.entity.bannerImage === null ||
            adminViewEntityDetail.entity.bannerImage === "string"
              ? COVER_URL
              : entitybanneruri
          }),url(${COVER_URL})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          position: "relative",
          marginBottom: "40px",
        }}
      >
        <Box
          sx={{
            // position: "absolute",
            width: "100%",
            height: "110px",
            bgcolor: "rgba(0, 0, 0, 0.54)",
            // display: "flex",
            // justifyContent: "flex-start",
          }}
        >
          <Avatar
            alt="Profile picture"
            src={
              adminViewEntityDetail.entity.profilePicture === "string" ||
              adminViewEntityDetail.entity.profilePicture === null
                ? AVATAR_URL
                : profilepictureuri
            }
            sx={{
              position: "absolute",
              backgroundColor: "green",
              margin: "0 30px",
              left: "0",
              right: "0",
              bottom: "0",
              borderRadius: "50%",
              width: "100px",
              height: "100px",
              transform: "translateY(50%)" /* additional 50% of own height */,
              boxShadow: "0 0 0 10px #fff",
              "& img": {
                height:
                  adminViewEntityDetail.entity.profilePicture === "string" ||
                  adminViewEntityDetail.entity.profilePicture === null
                    ? "100%"
                    : "100%",
                width:
                  adminViewEntityDetail.entity.profilePicture === "string" ||
                  adminViewEntityDetail.entity.profilePicture === null
                    ? "100%"
                    : "100%",
              },
            }}
          />
          <Typography
            variant="h6"
            sx={{
              position: "absolute",
              color: "white",
              left: "150px",
              right: "0",
              bottom: "20px",
              fontSize: "1.50rem!important",
            }}
          >
            {adminViewEntityDetail.entity.entityName}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          padding: 2,
        }}
      >
        <Accordion
          sx={{ border: "none", boxShadow: "none" }}
          defaultExpanded={true}
          className="testeacrd"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header2"
          >
            <Typography fontSize="26px" gutterBottom marginBottom="0px">
              <b className="boldNone">{t("profileDetails")}</b>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Paper
              variant="outlined"
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 1,
              }}
            >
              <Divider />
              <Typography variant="subtitle">
                <b>{t("profileQuestion")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {t(`${entityType}`)}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("activityQuestion")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {t(`${areaActivity}`)}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("entityTypeQuestion")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {t(`${entityTypeQuestion}`)}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("NIF/NIC")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.entity.nic}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("name")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.entity.entityName}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("id")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.entity.entityId}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("registrationEmail")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.email}
                {adminViewEntityDetail.status == 'PENDING_EMAIL_VERIFICATION' &&
                    <Button 
                    onClick={AbrirChangeEmail}
                    >
                    Alterar E-mail
                  </Button>
                }
               
              <div id="divChangeEmail" className="d-none">
                <Typography>E-mail</Typography>
                <input type="text" id="AlterarEmail"></input>
                <div className="BotoesMudarEmail">
                <Button
                sx={{backgroundColor: "#FFEEEE", color: "#FF0000" }} 
                  onClick={CancelarChangeEmail}
                  >
                  Cancelar
                </Button>
                <Button  sx={{ marginLeft :"10px" , color:" #fff",backgroundColor: "#37B34A"}}
                  onClick={updateRegister}
                  >
                  Guardar
                </Button>
                
                </div>
                
              </div>
              </Typography>
              
              <Typography variant="subtitle">
                <b>{t("status")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom> 
                {adminViewEntityDetail.status == 'PENDING_EMAIL_VERIFICATION' ? "Verificação de e-mail pendente" : adminViewEntityDetail.status}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("actionTakenOn")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.registrationApprovedRejectedOn}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("actionTakenBy")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.registrationApprovedRejectedBy}
              </Typography>
            </Paper>
          </AccordionDetails>
        </Accordion>
        <Divider />
        <Accordion sx={{ border: "none", boxShadow: "none" }}  className="testeacrd">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header2"
          >
            <Typography fontSize="26px" gutterBottom  marginBottom="0px">
              <b className="boldNone">{t("primaryAddress")}</b>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Paper
              variant="outlined"
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 1,
                mt: 1,
              }}
            >
              <Divider />
              <Typography variant="subtitle">
                <b>{t("addressTitle")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].addressTitle}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("houseHold")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].addressLine}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("district")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].district}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("county")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].county}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("parshi")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].subDivision}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("locality")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].locality}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("postcard")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].postalCode}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("addressEmail")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].email}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("phone")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.addresses[0].phone}
              </Typography>
              <Divider />
            </Paper>
          </AccordionDetails>
        </Accordion>
        <Divider />
        <Accordion sx={{ border: "none", boxShadow: "none" }} className="testeacrd">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header2"
            
          >
            <Typography fontSize="26px" gutterBottom  marginBottom="0px">
              <b className="boldNone">{t("contactDetail")}</b>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Paper
              variant="outlined"
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 1,
                mt: 1,
              }}
            >
              <Typography variant="subtitle">
                <b>{t("contactName")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.contact[0].name}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("email")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.contact[0].email}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("designation")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.contact[0].designation}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("mobile")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.contact[0].mobile}
              </Typography>
            </Paper>
          </AccordionDetails>
        </Accordion>
        <Divider />
        {/* <Accordion sx={{ border: "none", boxShadow: "none" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            {/* <Typography fontSize="26px" gutterBottom>
              <b>{t("document")}</b>
            </Typography> */}
          {/* </AccordionSummary>
          <AccordionDetails> */}
            {/* <Paper
              variant="outlined"
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 1,
                mt: 1,
              }}
            >
              <Typography variant="subtitle">
                <b>{t("businessRegistration")}</b>
              </Typography>
              <Typography
                variant="subtitle"
                gutterBottom
                component="a"
                href={
                  adminViewEntityDetail.businessRegistration !== null
                    ? adminViewEntityDetail.businessRegistration
                    : "#"
                }
                target="_blank"
              >
                {adminViewEntityDetail.businessRegistration !== null &&
                  adminViewEntityDetail.businessRegistration.slice(68)}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("mandatedStatement")}</b>
              </Typography>
              <Typography
                variant="subtitle"
                gutterBottom
                component="a"
                href={
                  adminViewEntityDetail.mandatedStatement !== null
                    ? adminViewEntityDetail.mandatedStatement
                    : "#"
                }
                target="_blank"
              >
                {adminViewEntityDetail.mandatedStatement != null &&
                  adminViewEntityDetail.mandatedStatement.slice(68)}
              </Typography>
             
            </Paper> */}
            {/* <DocumentDetails componentType={ComponentType.ADMIN_VIEW} t={t} /> */}
          {/* </AccordionDetails> */}
        {/* </Accordion> */}
        {/* <Divider />  */}
        <Accordion sx={{ border: "none", boxShadow: "none" }} className="testeacrd">
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header2"
          >
            <Typography fontSize="26px" gutterBottom  marginBottom="0px">
              <b className="boldNone" >{t("otherDetails")}</b>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Paper
              variant="outlined"
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 1,
                mt: 1,
              }}
            >
              <Typography variant="subtitle">
                <b>{t("totalDonations")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.totalNumberOfDonations}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("totalCollections")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.totalNumberOfCollections}
              </Typography>
              <Typography variant="subtitle">
                <b>{t("noOfChild")}</b>
              </Typography>
              <Typography variant="subtitle" gutterBottom>
                {adminViewEntityDetail.totalNumberOfChilds}
              </Typography>
            </Paper>
          </AccordionDetails>
        </Accordion>
        <Divider />
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          
        </Box>
      </Box>
    </>
  );
};

const ActionCell = (props) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const {
    auth: { profile: entity },
    adminDashboard: { entitiesOffset, entitiesLimit },
  } = useSelector((state) => state);

  const onViewClick = () => {
    dispatch(setDrawerState(true));
    dispatch(setAdminViewEntityDetail(props.dataItem));
  };

  const onApproved = React.useCallback(() => {
    const payload = {
      userId: props.dataItem.entity.entityId,
      status: RegistrationStatus.active,
      registrationApprovedRejectedOn: toLocalISOString(new Date()),
      registrationApprovedRejectedBy: entity.entityId,
    };
    dispatch(updateRegistrationDetail(payload))
      .unwrap()
      .then((res) => {
        let data = {
          limit: entitiesLimit,
          offset: entitiesOffset,
          status: RegistrationStatus.pendingEmailVerification,
        };
        dispatch(getEntitiesList(data));
        enqueueSnackbar({
          message: t("successfullyApproved"),
          variant: "success",
        });
      })
      .catch((error) => {
        enqueueSnackbar({
          message: t("somethingWentWrong"),
          variant: "error",
        });
      });
  }, []);

  const onRejectedHandle = React.useCallback(() => {
    const payload = {
      userId: props.dataItem.entity.entityId,
      status:
        props.dataItem.status === RegistrationStatus.active
          ? RegistrationStatus.inActive
          : RegistrationStatus.rejected,
      registrationApprovedRejectedOn: toLocalISOString(new Date()),
      registrationApprovedRejectedBy: entity.entityId,
    };
    dispatch(
      setHeaderTitle(
        props.dataItem.status === RegistrationStatus.active
          ? t("confirmationDeactivateContent")
          : t("confirmationRejectContent")
      )
    );
    dispatch(setRejectPayload(payload));
    dispatch(setConfirmationDialog(true));
  }, []);

  return (
    <td
      style={props.style} // this applies styles that lock the column at a specific position
      className={props.className} // this adds classes needed for locked columns
      colSpan={props.colSpan}
      role={"gridcell"}
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
    >
      <Stack direction={"row"} mt="10px" alignItems="center" spacing={1}>
        <Tooltip title={t("viewDetails")} arrow>
          <Button sx={{ p: 0, minWidth: 0 }} onClick={onViewClick}>
            <RemoveRedEyeIcon fontSize="small" />
          </Button>
        </Tooltip>
        {/* {props.dataItem.status !== RegistrationStatus.active && (
          <Tooltip title={t("approved")} arrow>
            <Button sx={{ p: 0, minWidth: 0,padding:2}} onClick={onApproved}>
              <DoneIcon fontSize="small" />
            </Button>
          </Tooltip>
        )}
        {(props.dataItem.status !== RegistrationStatus.rejected ||
          props.dataItem.status !== RegistrationStatus.revoked ||
          props.dataItem.status !== RegistrationStatus.inActive) && (
          <Tooltip title={t("rejected")} arrow>
            <Button sx={{ p: 0, minWidth: 0,padding :props.dataItem.status === RegistrationStatus.active ? 1.5:0 }} onClick={onRejectedHandle}>
              <ClearIcon fontSize="small" />
            </Button>
          </Tooltip>
        )} */}
      </Stack>
    </td>
  );
};

const StatusFilterCell = (props) => {
  return (
    <DropdownFilterCell
      {...props}
      data={Object.values(RegistrationPortugeseStatusPendingRegister)}
      defaultItem={"Selecione um  Estado"}
    />
  );
};

const DistrictFilterCell = (props) => {
  return (
    <DropdownFilterCell
      {...props}
      data={AddressData.map((item) => item.district)}
      defaultItem={"Selecione um Distrito"}
    />
  );
};

const CountyFilterCell = (props) => {
  const {
    adminDashboard: { adminGridDistrictSelect },
  } = useSelector((state) => state);

  const countyNames = React.useMemo(() => {
    if (adminGridDistrictSelect !== "") {
      return AddressData.find(
        (item) => item.district === adminGridDistrictSelect
      ).county.map((item) => item.countyName);
    }
    return [];
  }, [adminGridDistrictSelect]);

  return (
    <DropdownFilterCell
      {...props}
      data={countyNames}
      defaultItem={"Selecione um Concelho"}
    />
  );
};

const FerguesiaFilterCell = (props) => {
  const {
    adminDashboard: { adminGridDistrictSelect, adminGridCountySelect },
  } = useSelector((state) => state);

  const freguesiaNames = React.useMemo(() => {
    if (adminGridDistrictSelect !== "" && adminGridCountySelect !== "") {
      return AddressData.find(
        (item) => item.district === adminGridDistrictSelect
      )
        .county.find((item) => item.countyName === adminGridCountySelect)
        .fregusias.map((item) => item.freguesiaName);
    }
    return [];
  }, [adminGridDistrictSelect, adminGridCountySelect]);

  return (
    <DropdownFilterCell
      {...props}
      data={freguesiaNames}
      defaultItem={"Selecione uma Freguesia"}
    />
  );
};

const PendingRegister = ({ t }) => {
  const {
    adminDashboard: {
      entitiesList,
      entitiesCount,
      drawerState,
      rejectPayload,
      entitiesLimit,
      entitiesOffset,
      confirmationDialog,
      loading,
      headerTitle,
    },
  } = useSelector((state) => state);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const handleClose = React.useCallback(() => {
    dispatch(setConfirmationDialog(false));
  }, [dispatch]);

  const onConfirm = () => {
    dispatch(updateRegistrationDetail(rejectPayload))
      .unwrap()
      .then((res) => {
        let data = {
          limit: entitiesLimit,
          offset: entitiesOffset,
          status: RegistrationStatus.pendingEmailVerification,
        };
        dispatch(getEntitiesList(data));
        dispatch(setConfirmationDialog(false));
        dispatch(setDrawerState(false));
        enqueueSnackbar({
          message:
            rejectPayload.status === RegistrationStatus.active
              ? t("successfullyDeactivated")
              : t("successfullyRejected"),
          variant: "success",
        });
      })
      .catch((error) => {
        enqueueSnackbar({
          message: t("somethingWentWrong"),
          variant: "error",
        });
      });
  };

  const filterOperators = {
    text: [
      {
        text: "grid.filterContainsOperator",
        operator: "contains",
      },
    ],
    numeric: [
      {
        text: "grid.filterEqOperator",
        operator: "eq",
      },
    ],
    date: [
      {
        text: "grid.filterEqOperator",
        operator: "eq",
      },
    ],
    boolean: [
      {
        text: "grid.filterEqOperator",
        operator: "eq",
      },
    ],
  };

  const timer = React.useRef(null);
  const [dataState, setDataState] = React.useState({
    take: 20,
    skip: 0,
  });

  React.useEffect(() => {
    const data = {
      limit: dataState.take + dataState.skip,
      offset: dataState.skip,
      status: RegistrationStatus.pendingEmailVerification,
    };
    dispatch(getEntitiesList(data));
  }, []);

  const debouncedApiCall = debounce(async (value) => {
    const limit = value.skip + value.take;
    const offset = value.skip;
    let data = {
      limit: limit,
      offset: offset,
      status: RegistrationStatus.pendingEmailVerification,
    };
    if (value.filter !== undefined) {
      value?.filter.filters.map((item) => {
        switch (item.field) {
          case "district":
            data["district"] = item.value;
            dispatch(setAdminGridDistrictSelect(item.value));
            break;
          case "county":
            data["county"] = item.value;
            dispatch(setAdminGridCountySelect(item.value));
            break;
          case "subDivision":
            data["subDivison"] = item.value;
            break;
          case "entity.entityName":
            data["entityName"] = item.value;
            break;
          case "status":
            data["status"] = Object.keys(RegistrationPortugeseStatusPendingRegister).find(
              (key) => RegistrationPortugeseStatusPendingRegister[key] === item.value
            );
            break;
        }
      });
    } else {
      dispatch(setAdminGridDistrictSelect(""));
      dispatch(setAdminGridCountySelect(""));
    }
    dispatch(getEntitiesList(data));
    dispatch(setEntitiesLimit(limit));
    dispatch(setEntitiesOffset(offset));
  }, 1000);

  const dataStateChange = (e) => {
    const value = e.dataState;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      debouncedApiCall(value);
    }, 1000);
    setDataState(e.dataState);
  };

  return (
    <React.Fragment>
      {loading && <Loader phrase={"adminEntitiesLoadingPhrase"} t={t} />}
      {!loading && (
        <>
        
        <LocalizationProvider language="pt-PT" >
          <IntlProvider locale="pt">
          <Grid
          data={entitiesList}
          resizable={true}
          style={{ height: "70vh" }}
          // skip={page.skip}
          // take={page.take}
          filterOperators={filterOperators}
          total={entitiesCount}
          pageable={true}
          {...dataState}
          // onPageChange={pageChange}
          onDataStateChange={dataStateChange}
          filterable={true}
          // groupable={true}
        >
          <GridNoRecords>{t("noRecordAvailable")}</GridNoRecords>
          {/* <Column
            field="entity.entityId"
            title={t("id")}
            filterable={false}
            width={"200px"}
          /> */}
          <Column
            field="entity.entityName"
            title={t("name")}
            filter={"text"}
            width={"280px"}
            minResizableWidth={200}
            locked={true}
          />
          {/* <Column
            field="userType"
            title={t("type")}
            filterable={false}
            width={"150px"}
            cell={TypeCell}
          /> */}
           {/* <Column
            field="totalNumberOfCollections"
            title={t("totalCollections")}
            filterable={false}
            width={"100px"}
          /> */}
          {/* <Column
            field="entity.isParentEntity"
            title={t("companyType")}
            filterable={false}
            cell={CompanyCell}
            width={"100px"}
          />
          <Column
            field="totalNumberOfChilds"
            title={t("noOfChild")}
            filterable={false}
            width={"100px"}
          />
          <Column
            field="entity.entityType"
            title={t("profile")}
            filterable={false}
            cell={ProfileCell}
            width={"250px"}
          /> */}
          <Column
            field="entity.areaOfActivity"
            title={`${t("activity")}`}
            cell={AreaOfActivityCell}
            filterable={false}
            width={"150px"}
          />
          <Column
            field="entity.isGroupEntity"
            title={`${t("groupEntity")}`}
            cell={GroupEntityCell}
            filterable={false}
            width={"150px"}
          />
          <Column
            field="district"
            title={t("district")}
            filterCell={DistrictFilterCell}
            cell={DistrictCell}
            width={"300px"}
          />
          <Column
            field="county"
            title={t("county")}
            filterCell={CountyFilterCell}
            cell={CountyCell}
            width={"350px"}
          />
          <Column
            field="subDivision"
            title={t("parshi")}
            filterCell={FerguesiaFilterCell}
            cell={SubDivisionCell}
            width={"350px"}
          />
          <Column
            field="telefone"
            title={`${t("phone")}`}
            cell={TelephoneCell}
            filterable={false}
            width={"150px"}
          />
          <Column
            field="status"
            title={t("status")}
            filterCell={StatusFilterCell}
            cell={StatusCell}
            width={"350px"}
          />
          <Column
            field=""
            title={`Ações`}
            cell={ActionCell}
            filterable={false}
            width={"100px"}
            minResizableWidth={100}
            locked={true}
          />
        </Grid>
          </IntlProvider>
        </LocalizationProvider>
        </>
        
      )}
      {/* <EntitiesLoader dataState={dataState} /> */}
      <Drawer
        anchor={"right"}
        open={drawerState}
        PaperProps={{
          sx: { width: "50%" },
        }}
        onClose={() => {
          dispatch(setDrawerState(false));
        }}
      >
        <Button
          sx={{
            position: "fixed",
            right: "51%",
            top: 10,
            zIndex: 1,
            minWidth: 0,
            borderRadius: "4px",
            padding: "4px",
            backgroundColor: "#ffc3c3",
            "&:hover": {
              backgroundColor: "#ffc3c3",
            },
            "@media (max-width:900px)": {
              right: "1%",
            },
          }}
          onClick={() => {
            dispatch(setDrawerState(false));
          }}
        >
          <CloseOutlinedIcon color="error" />
        </Button>
        <ViewEntityDetails t={t} />
      </Drawer>
      <ConfirmDialog
        open={confirmationDialog}
        handleClose={handleClose}
        title={t("")}
        content={headerTitle}
        onConfirm={onConfirm}
        cancelButtonTitle={t("cancel")}
        confirmButtonTitle={t("confirm")}
      />
    </React.Fragment>
  );
};

export default PendingRegister;
